import Search from "./search.component";

export default Search;
